import { render, staticRenderFns } from "./Q14Info.vue?vue&type=template&id=fd30775c&"
import script from "./Q14Info.vue?vue&type=script&lang=ts&"
export * from "./Q14Info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports